import {connect} from '../../app/connect';
import TemplatesProjectGrid from './TemplatesProjectGrid';
import {
  fetchIssueTemplateCategoriesAction,
  changeLocationAction,
  setQueryParamsAction,
  fetchIssueTemplatesAction
} from '../../app/actions';
import {
  getTemplateOrderedList,
  getTemplatesQueryParams,
  isShowNewTemplateModal,
  isTemplatesCollectionLoading,
  isTemplatesCollectionError,
  isTemplatesFilterChanged,
  isTemplatesSearchChanged
} from '../../app/selectors';

const mapStateToProps = state => ({
  isTemplatesCollectionError: isTemplatesCollectionError(state),
  isTemplatesCollectionLoading: isTemplatesCollectionLoading(state),
  isFiltered: isTemplatesFilterChanged(state),
  isSearched: isTemplatesSearchChanged(state),
  tableData: getTemplateOrderedList(state),
  isShowNewTemplateModal: isShowNewTemplateModal(state),
  queryParams: getTemplatesQueryParams(state)
});

const mapDispatchToProps = {
  fetchIssueTemplateCategoriesAction,
  fetchIssueTemplatesAction,
  changeLocationAction,
  setQueryParamsAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplatesProjectGrid);
